import React from 'react'
import Carousels from "../componnents/carousels/Carousels";
import Todo from "../componnents/todo/Todo"
import Choose from '../choose/Choose';
import Presence from '../our presence/Presence';
// import Navbar3 from '../componnents/Navbar3';
// import Navbar4 from '../componnents/Navbar4';
// import App from '../our presence/App';
import "./Home.css";
// import Carousels2 from '../componnents/carousels/Carousels2';
// import Carousels3 from '../componnents/carousels/Carousels3';
// import {FaYoutube,FaTwitter,FaCartPlus} from "react-icons";

const Home = () => {
  return (
<>
    <div>
    <div>
        <Carousels />
        {/* <Navbar3 /> */}
        {/* <Navbar4 /> */}
        {/* <Carousels2 /> */}
        {/* <Carousels3 /> */}
        <div className="section">
          <div className="container">
            <div className="content-section">
              <div className="title">
                <h1>About Us</h1>
              </div>
              <div className="content">
                <h3>At Somnath Polytex, we take pride in our journey that started with a vision to provide the finest woven products to the world. With years of expertise and a commitment to innovation, we have grown to become a leading name in the industry. Our state-of-the-art facilities and a team of dedicated professionals ensure that every product we create is of the highest quality and meets the stringent standards of our customers. We specialize in manufacturing and supplying a wide range of PP woven fabric, PP woven sack bags, and fabric bags that meet your packaging needs with excellence. Explore our products and discover the difference of exceptional craftsmanship and reliability.</h3>
                {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt inventore vitae doloremque dolore ut iusto recusandae beatae esse mollitia voluptate optio atque totam autem non blanditiis, odit commodi ullam repellat.</p> */}
                {/* <div className="button">
                  <a href="">Read More</a>
                </div> */}
              </div>
              <div className="social">
                {/* <a href=""><i className='fab fa-facebook-f'></i></a>
                <a href=""><i className='fab FaTwitter'></i></a>
                <a href=""><i className='fab fa-instagram'></i></a> */}
              </div>
            </div>
            <div className="image-section">
              <img src="/images/19.jpg" alt="" />
            </div>
          </div>
        </div>
        
    </div>
   
   
   
   </div>

   <div>
   
   <Todo />           
   <Choose />
   <Presence />
   {/* <App /> */}
   </div>
   </>


  )
}

export default Home
